import { ErrorHandler, Injectable, inject } from '@angular/core';
import { RaygunService } from './raygun.service';

@Injectable()
export class RaygunErrorHandler implements ErrorHandler {
  private raygunService = inject(RaygunService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {

    try {
      let errorToSend: Error;

      if (error?.rejection) {
        errorToSend = error.rejection instanceof Error ? error.rejection : new Error(String(error.rejection));
      } else if (error instanceof Error) {
        errorToSend = error;
      } else {
        try {
          errorToSend = new Error(JSON.stringify(error, Object.getOwnPropertyNames(error)));
        } catch {
          errorToSend = new Error(String(error));
        }
      }

      this.raygunService.sendError(errorToSend);
    } catch (raygunError) {
      console.error('Failed to send error to Raygun:', raygunError);
    }
  }
}